module.exports = __webpack_public_path__ + "static/img_0420-88a847990357e7725856e2f99d1942d8.webp";